// extracted by mini-css-extract-plugin
export default {"orderStatus":"KVxiMuUS9gr88BJ1DAKM","checkmark":"evzwebk7is3YytbAQinP"};